import PanelBox from '../../components/PanelBox';
import React, { Component } from 'react'
import { connect } from "react-redux";
import { Modal, Table, Form, Input, Tooltip, Icon, Cascader, Select, Row, Col, Checkbox, Button, Upload, notification } from 'antd';
import { getClientJobs, getLinks } from '../../actions/jobs';
import moment from 'moment';

const case_status = {
  '-3' :    '-3',
  '-2' :    '-2',
  '-1' :    '-1',
  '0'  :    'Draft',
  '1'  :    'Upload',
  '10' :    'Upload done',
  '20' :    'Computing',
  '30' :    '30',
  '40' :    'Ready',
  '45' :    '45',
  '50' :    '50',
  '100':    '100'
}

const download_links = {
  'bone_aligned_l' : 'Lower bone',
  'teeth_aligned_l': 'Lower teeth',
  'bone_aligned_u' : 'Upper bone',
  'teeth_aligned_u': 'Upper teeth'
}

const mapStateToProps = (state) => {
  return {
    jobs: state.jobs,
    links: state.links
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getClientJobs: () => dispatch(getClientJobs()),
    getLinks: (uuid) => dispatch(getLinks(uuid)),
    eraseJobs: () => dispatch({type: 'ERASE_JOBS'}),
    eraseLinks: () => dispatch({type: 'ERASE_LINKS'})
  }
}


class CaseTableClient extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      sorted_jobs: [],
      searchValue: '',
      sortedInfo: {
        order: 'descend',
        columnKey: 'created',
      },
    };
    this.getLinks = this.getLinks.bind(this)
    this.showDownloadModal = this.showDownloadModal.bind(this)
  }

  componentDidMount() {
    this.props.getClientJobs()
    this.setState({'tableLoading': true})
  }

  componentWillReceiveProps(nextProps) {
    nextProps.jobs ? this.setState({tableLoading: false}) : null
    this.state.showModal && nextProps.links && this.showDownloadModal(nextProps.links)
  }

  componentWillUnmount() {
    this.props.eraseJobs()
  }

  onSearcHandler(searchText) {
    let filtred_data = []
    let table_data = this.props.jobs
    this.setState({'searchValue':searchText})
    if (searchText !== '') {
      table_data.map((record) => {
        let match = false
        Object.values(record).map((value) => {
          if (value && Object.values(value).length) {
            Object.values(value).map((subvalue)=>{
              if (subvalue && subvalue.toString().toUpperCase().indexOf(searchText.toUpperCase()) != -1) {
                match = true
              }
            })
          } else if (value && value.toString().toUpperCase().indexOf(searchText.toUpperCase()) != -1) {
            match = true
          }
        })
        match ? filtred_data.push(record) : null
      })
    }
    this.setState({'sorted_jobs':filtred_data})
  }

  
  handleChange = (pagination, filters, sorter) => {
    this.setState({
      filteredInfo: filters,
      sortedInfo: sorter,
    });
  }

  showDownloadModal(links) {
    this.setState({showModal:false})
    Modal.info({
      title: 'Download files',
      iconType: "download",
      content: (
        Object.keys(links).length ?
        <div style={{marginTop:8}}>
          {Object.keys(links).map((item,key)=>(
            <p key={key}><a href={links[item]}>{download_links[item]}</a></p>)
          )}
        </div> 
        :
        <div style={{marginTop:8}}>
          <p>No files available</p>
        </div>
      ),
      onOk() {
      },
    });
  }

  getLinks(uuid) {
    this.props.getLinks(uuid)
    this.setState({showModal:true})
  }
 
  render() {
    let { sortedInfo } = this.state;
    sortedInfo = sortedInfo || {};

    const columns = [{
      title: 'id',
      dataIndex: 'uuid',
      render: (id) => id.slice(0,8),
      key: 'id',
      sorter: (a, b) => a.uuid - b.uuid,
      sortOrder: sortedInfo.columnKey === 'uuid' && sortedInfo.order,
    }, {
      title: 'Patient tag',
      dataIndex: 'ct_scan.patient_tag',
      key: 'patient_tag',
      sorter: (a, b) => a.ct_scan.patient_tag - b.ct_scan.patient_tag,
      sortOrder: sortedInfo.columnKey === 'patient_tag' && sortedInfo.order,
    }, {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status) => case_status[status],
      sorter: (a, b) => a.status - b.status,
      sortOrder: sortedInfo.columnKey === 'status' && sortedInfo.order,
    }, {
      title: 'Updated',
      dataIndex: 'last_modified',
      render: (date) => moment(date).format('DD-MM-YYYY'),
      key: 'last_modified',
      sorter: (a, b) => Date.parse(a.last_modified) - Date.parse(b.last_modified),
      sortOrder: sortedInfo.columnKey === 'last_modified' && sortedInfo.order,
    }, {
      title: 'Created',
      dataIndex: 'created',
      render: (date) => moment(date).format('DD-MM-YYYY'),
      key: 'created',
      sorter: (a, b) => Date.parse(a.created) - Date.parse(b.created),
      sortOrder: sortedInfo.columnKey === 'created' && sortedInfo.order,
    }];

    return (
      <PanelBox title={"Case table"}>
          <Row type="flex" justify="end" style={{ marginBottom: 16 }}>
            <Input
                prefix={<Icon type="search" />}
                placeholder="Search"
                style={{ width: 200 }}
                onChange={(e) => this.onSearcHandler(e.target.value)}
            />
        </Row>
        <Table 
          dataSource={this.state.searchValue != '' ? this.state.sorted_jobs : this.props.jobs} 
          columns={columns}
          rowKey="uuid"
          loading={this.state.tableLoading}
          onChange={this.handleChange}
          onRowClick={(index)=>{
            this.getLinks(index.uuid)}
          }
        />
      </PanelBox>
    );
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(CaseTableClient)


// WEBPACK FOOTER //
// ./src/views/Cases/caseTableClient.jsx